import React from "react";
import { useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Slider.css";

const Slider = () => {
  const navigate = useNavigate();
  const handleButtonClick = (event) => {
    const sliderUrl = event.currentTarget.dataset.path;
    const openInNewTab = event.currentTarget.dataset.newTab === 'true';

    if (openInNewTab) {
      window.open(sliderUrl, '_blank', 'noopener,noreferrer');
    } else {
      navigate(sliderUrl);
    }
  };

  return (
    <>
      <Swiper
        navigation={true}
        pagination={{ clickable: true }}
        modules={[Navigation, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide
          className="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-1.jpg)`,
          }}
        >
          <span>The Big 6</span>
          <button
            data-path="/datavis/frequently-used-words-in-neo-slave-narratives#expanded"
            data-new-tab="true"
            onClick={handleButtonClick}
          >
            The Most Frequently Featured Authors in African American Review
          </button>
        </SwiperSlide>
        <SwiperSlide
          className="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-2.jpg)`,
          }}
        >
          <span>Literary Navigator Device</span>
          <button data-path="/publications" onClick={handleButtonClick}>
            Find What To Read Next
          </button>
        </SwiperSlide>
        <SwiperSlide
          className="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-3.jpg)`,
          }}
        >
          <span>The Spoken Word</span>
          <button data-path="/podcasts" onClick={handleButtonClick}>
            Listen to a Podcast
          </button>
        </SwiperSlide>
        <SwiperSlide
          className="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-4.jpg)`,
          }}
        >
          <span>T'Challa Rising</span>
          <button
            data-path="/datavis/black-panther-prints-reprints-and-variants#expanded"
            data-new-tab="true"
            onClick={handleButtonClick}
          >
            Black Panther Prints, Reprints, and Variants
          </button>
        </SwiperSlide>
        <SwiperSlide
          className="Slider1"
          style={{
            backgroundImage: `url(/assets/img/banners/Slide-5.jpg)`,
          }}
        >
          <span>The Sisterhood</span>
          <button
            data-path="/podcasts/the-sisterhood-1977-photograph"
            onClick={handleButtonClick}
          >
            The story of an inspirational 1977 photo
          </button>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default Slider;
